import React, { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Section from 'components/Section';
import TwoColumn from 'components/TwoColumn';

import { OrderEditMainContacts_order$key } from '__generated__/OrderEditMainContacts_order.graphql';
import { SCORO_URL } from 'const';
import Stack from '@mui/material/Stack';

type Props = {
  order: OrderEditMainContacts_order$key;
};

const OrderEditMainContacts: FC<Props> = ({ order }) => {
  const { phone, email, scoroContactId, scoroOrderId } = useFragment(
    graphql`
      fragment OrderEditMainContacts_order on Order {
        phone
        email
        scoroContactId
        scoroOrderId
      }
    `,
    order
  );

  return (
    <Section id="contacts" title="Kontaktai">
      <Stack spacing={4}>
        <TwoColumn
          left={
            <TextField
              fullWidth
              disabled
              label="Telefonas"
              variant="standard"
              value={phone}
            />
          }
          right={
            <TextField
              fullWidth
              disabled
              label="El. paštas"
              variant="standard"
              value={email}
            />
          }
        />

        <TwoColumn
          left={
            <TextField
              fullWidth
              disabled
              label="Scoro contact ID"
              variant="standard"
              value={scoroContactId}
              helperText={
                <Link
                  href={`${SCORO_URL}/companies/view/${scoroContactId}`}
                  target="_blank"
                  rel="noopener noreferrer">
                  Scoro CRM puslapis
                </Link>
              }
            />
          }
          right={
            <TextField
              fullWidth
              disabled
              label="Scoro order ID"
              variant="standard"
              value={scoroOrderId}
              helperText={
                <Link
                  href={`${SCORO_URL}/orders/view/${scoroOrderId}`}
                  target="_blank"
                  rel="noopener noreferrer">
                  Scoro CRM puslapis
                </Link>
              }
            />
          }
        />
      </Stack>
    </Section>
  );
};

export default OrderEditMainContacts;
